// React
import { ReactElement } from 'react';
// Features
import { Magazine } from '@utmb/features/utmb-news/Magazine';
// Contexts
import { MagsProvider } from '@utmb/contexts/MagsContext';
// Types
import SliceListOfMagsView from '@utmb/types/view/SliceListOfMagsView';
// Styles
import styles from './magazine.module.scss';

export const MagazineContainer = ({ articles, filters }: SliceListOfMagsView): ReactElement => {
    return (
        <section className={`${styles.container} container`}>
            <MagsProvider result={articles} filters={filters}>
                <Magazine />
            </MagsProvider>
        </section>
    );
};
